export function normalizeSearchText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9@._+-]+/g, " ")
    .trim();
}

function editDistance(left, right) {
  const a = normalizeSearchText(left);
  const b = normalizeSearchText(right);
  if (!a) return b.length;
  if (!b) return a.length;

  const previous = Array.from({ length: b.length + 1 }, (_, index) => index);
  for (let row = 1; row <= a.length; row += 1) {
    const current = [row];
    for (let column = 1; column <= b.length; column += 1) {
      current[column] = Math.min(
        current[column - 1] + 1,
        previous[column] + 1,
        previous[column - 1] + (a[row - 1] === b[column - 1] ? 0 : 1)
      );
    }
    previous.splice(0, previous.length, ...current);
  }
  return previous[b.length];
}

function tokenMatches(queryToken, candidateToken) {
  if (candidateToken.includes(queryToken) || queryToken.includes(candidateToken)) return true;
  const longest = Math.max(queryToken.length, candidateToken.length);
  const tolerance = longest >= 9 ? 3 : longest >= 5 ? 2 : longest >= 3 ? 1 : 0;
  return editDistance(queryToken, candidateToken) <= tolerance;
}

export function fuzzyTextMatch(candidate, query) {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return true;

  const normalizedCandidate = normalizeSearchText(candidate);
  if (!normalizedCandidate) return false;
  if (normalizedCandidate.includes(normalizedQuery)) return true;

  const candidateTokens = normalizedCandidate.split(/\s+/).filter(Boolean);
  return normalizedQuery
    .split(/\s+/)
    .filter(Boolean)
    .every((queryToken) => candidateTokens.some((candidateToken) => tokenMatches(queryToken, candidateToken)));
}

export function getHostAccountLabel(session) {
  const email = String(session?.hostEmail || "").trim();
  const name = String(session?.hostName || session?.hostUsername || "").trim();
  if (email && name && normalizeSearchText(email) !== normalizeSearchText(name)) {
    return `${email} (${name})`;
  }
  return email || name || "Unknown";
}

export function sessionMatchesHostAccount(session, query) {
  return fuzzyTextMatch(
    [
      getHostAccountLabel(session),
      session?.hostEmail,
      session?.hostName,
      session?.hostUsername,
    ].filter(Boolean).join(" "),
    query
  );
}
